import { render, staticRenderFns } from "./StatementForm.vue?vue&type=template&id=766be14c&scoped=true"
import script from "./StatementForm.vue?vue&type=script&lang=js"
export * from "./StatementForm.vue?vue&type=script&lang=js"
import style0 from "./StatementForm.vue?vue&type=style&index=0&id=766be14c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766be14c",
  null
  
)

export default component.exports